import Firebase from 'firebase'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'

const logIn = () => {
  return logInWithGoogle()
    .then( user => {
      ReactGA.event({
        category: 'User',
        action: 'Logged in with Google',
      })
      ReactGA.set({ userId: user.uid })
      toast('Signed in')
    }).catch( error => {
      console.error('Could not sign in', error)
      toast.error('Sorry, we couldn\'t sign you in--try again in a minute?')
    })
}

const logInWithGoogle = () => {
  let provider = new Firebase.auth.GoogleAuthProvider()
  return Firebase.auth().signInWithRedirect(provider).then(result => result.user)
}

export default logIn



// WEBPACK FOOTER //
// ./src/actions/logIn.js